import { render, staticRenderFns } from "./GalleryCreativesItem.vue?vue&type=template&id=0c0f2174"
import script from "./GalleryCreativesItem.vue?vue&type=script&lang=js"
export * from "./GalleryCreativesItem.vue?vue&type=script&lang=js"
import style0 from "./GalleryCreativesItem.vue?vue&type=style&index=0&id=0c0f2174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports